import { useState } from "react";
import CardBack from "./CardBack/CardBack";
import CardFront from "./CardFront/CardFront";

const FlipCard = (props) => {
  const [isFlipped, setIsFlipped] = useState(false);

  const flip = () => {
    setIsFlipped((prevState) => {
      return !prevState;
    });
  };
  return (
    <div
      onMouseEnter={flip}
      onMouseLeave={flip}
      className={
        "col-lg-4 col-md-6 card-container" + (isFlipped ? " flipped" : "")
      }
    >
      <CardFront
        courseLogoPath={props.courseLogoPath}
        courseLogoAlt={props.courseLogoAlt}
        providerLogoPath={props.providerLogoPath}
        providerLogoAlt={props.providerLogoAlt}
      />
      <CardBack title={props.title} instructor={props.instructor} />
    </div>
  );
};

export default FlipCard;
